'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartDiscountPill } from './cart-discount-pill.component';
import { CartItemPrice } from './cart-item-price.component';

import { CartItem } from '@/types/cart.types';
import { hasCartItemCouponDiscount, isPromotionalCartItem } from '@/utils/cart/get-cart-total.util';
import { Typography } from '@/components/ui/typography/typography.component';

interface CartItemProcedureProps {
  item: CartItem;
}

export function CartItemProcedure({ item }: CartItemProcedureProps) {
  const hasPromotion = isPromotionalCartItem(item);
  const hasCoupon = hasCartItemCouponDiscount(item);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col">
        <Typography
          className="text-base leading-6 text-gray-700"
          data-testid={DataTestIdEnum.CART_ITEM_PROCEDURE}
        >
          {item.procedure.name}
        </Typography>

        <CartItemPrice item={item} />
      </div>

      {hasPromotion && <CartDiscountPill variant="promotion" />}

      {hasCoupon && <CartDiscountPill variant="coupon" />}
    </div>
  );
}
